<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row>
      <v-col cols="12" sm="12" md="6" v-if="user.tipo == 'ADMIN'">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaTerminais(empresaSelecionada)"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">TERMINAIS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Procurar" single-line hide-details></v-text-field>
              <v-spacer v-if="user.tipo == 'ADMIN'"></v-spacer>
              <v-btn text @click="dialogoTerminal = true" tile color="#3BA8A2" v-if="user.tipo == 'ADMIN'">
                <v-icon left dark>add_circle</v-icon>Cadastrar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" :disabled="item.tipo != 'LEITOR' || !item.ativo">
                  <v-icon @click="abrirCatraca(item)" color="green">mdi-door-open</v-icon>
                </v-btn>
              </template>
              <span>Abrir catraca</span>
            </v-tooltip>
            <v-tooltip bottom v-if="user.tipo == 'ADMIN'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom v-if="user.tipo == 'ADMIN'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="deleteItem(item)" color="#FF0000">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <v-icon :color="item.ativo == true ? 'success' : 'error'">mdi-circle</v-icon>
          </template>
          <template v-slot:no-data>
            <v-row style="margin: 0px">
              <v-col>
                <v-alert v-if="user.tipo == 'ADMIN' && empresaSelecionada == ''" dark dense text outlined color="info" icon="info" style="margin: 0px">Selecione uma empresa para visualizar os painéis</v-alert>
                <v-alert v-if="empresaSelecionada" dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum terminal cadastrado</v-alert>
                <v-alert v-if="user.tipo != 'ADMIN'" dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum terminal cadastrado</v-alert>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoTerminal" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text style="padding-bottom: 10px; padding-top: 10px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="Nome*"
                outlined
                dense
                hide-details
                v-model="editedItem.nome"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-text-field
                label="ID de dispositivo*"
                outlined
                dense
                hide-details
                v-model="editedItem.deviceId"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-switch
                v-model="editedItem.ativo"
                :label="editedItem.ativo ? 'Ativo' : 'Inativo'"
                inset
                hide-details
                style="padding: 0px; margin-top: 8px"
              ></v-switch>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-select
                v-model="editedItem.tipo"
                label="Tipo de terminal*"
                outlined
                dense
                hide-details
                :items="tiposTerminal"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-select
                v-model="editedItem.funcao"
                label="Função de terminal*"
                outlined
                dense
                hide-details
                :items="funcoesTerminal"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-text-field
                label="Endereço IP*"
                outlined
                dense
                hide-details
                v-model="editedItem.ip"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-text-field
                label="Porta*"
                outlined
                dense
                hide-details
                v-model="editedItem.porta"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-text-field
                label="Usuário*"
                outlined
                dense
                hide-details
                v-model="editedItem.usuario"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-text-field
                label="Senha*"
                outlined
                dense
                hide-details
                v-model="editedItem.senha"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-select
                v-model="editedItem.gruposPermitidos"
                label="Grupos permitidos"
                outlined
                dense
                hide-details
                item-text="tipoPessoa"
                item-value="tipoPessoa"
                :items="gruposTerminal"
                multiple
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoTerminal = false">Fechar</v-btn>
          <v-btn text color="success" @click="salvarTerminal" v-if="editedIndex == -1">Salvar</v-btn>
          <v-btn text color="success" @click="editarTerminal" v-if="editedIndex != -1">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      empresas: [],
      empresaSelecionada: '',
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'Tipo', value: 'tipo' },
          { text: 'Função', value: 'funcao' },
          { text: 'Endereço IP', value: 'ip' },
          { text: 'Porta', value: 'porta' },
          { text: 'Ativo', value: 'ativo' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      sexos: [
        { text: 'Masculino', value: 'MASCULINO' },
        { text: 'Feminino', value: 'FEMININO' },
      ],
      dialogoTerminal: false,
      editedIndex: -1,
      editedItem: {
        nome: '',
        deviceId: '',
        tipo: '',
        funcao: '',
        ip: '',
        porta: '',
        usuario: '',
        senha: '',
        ativo: true,
        empresaId: '',
        gruposPermitidos: [],
      },
      defaultItem: {
        nome: '',
        deviceId: '',
        tipo: '',
        funcao: '',
        ip: '',
        porta: '',
        usuario: '',
        senha: '',
        ativo: true,
        empresaId: '',
        gruposPermitidos: [],
      },
      tiposTerminal: ['LEITOR'],
      funcoesTerminal: ['ENTRADA', 'SAÍDA'],
      gruposTerminal: [],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo terminal' : 'Editar terminal'
      },
    }),

    watch: {
      dialogoTerminal(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedIndex = -1
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      },

      empresas() {
        this.empresaSelecionada = this.empresas[0].id
        this.carregaTerminais(this.empresaSelecionada)
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaTerminais(this.companyobj.id)
      }
      
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaTerminais(id) {
        this.carregaGrupos(id)
        this.tabela.conteudo = []
        this.tabela.carregamento = true
        await axios.get(baseApiUrl + 'Terminais?filter={"where":{"empresaId":"' + id + '"}, "order": "nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }
        })
      },

      async carregaGrupos(empresaId) {
        await axios.get(baseApiUrl + 'Grupos?filter={"where":{"empresaId":"' + empresaId + '"}, "order": "tipoPessoa ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.gruposTerminal = response.data
          }
        })
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoTerminal = true
        this.isLoading = false
      },

      async salvarTerminal() {
        var vm = this;

        if (!this.editedItem.nome || !this.editedItem.deviceId || !this.editedItem.tipo || !this.editedItem.funcao ||
            !this.editedItem.ip  || !this.editedItem.porta || !this.editedItem.usuario || !this.editedItem.senha
        ) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos para prosseguir", "ATENÇÃO")
        }
        else {
          this.isLoading = true
          this.editedItem.empresaId = this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id

          await axios.post(baseApiUrl + 'Terminais?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              if (response.data) {
                this.dialogoTerminal = false
                vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
                this.carregaTerminais(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
              }
            }
          })
          .catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#FF0000", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
          this.isLoading = false
        }
      },

      async editarTerminal() {
        var vm = this;

        if (!this.editedItem.nome || !this.editedItem.deviceId || !this.editedItem.tipo || !this.editedItem.funcao ||
            !this.editedItem.ip  || !this.editedItem.porta || !this.editedItem.usuario || !this.editedItem.senha
        ) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos para prosseguir", "ATENÇÃO")
        }
        else {
          this.isLoading = true

          await axios.put(baseApiUrl + 'Terminais/' + this.editedItem.id + '?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoTerminal = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaTerminais(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
            }           	
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação", "#BF4554")
          })
        }
      },

      async deleteItem(item) {
        var r = confirm('Realmente deseja EXCLUIR o terminal ' + item.nome + '?')

        if (r == true) {
          await axios.delete(baseApiUrl + 'Terminais/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {    
            var vm = this;
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaTerminais(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
          })
        }
      },

      async abrirCatraca(item) {
        this.isLoading = true

        await axios.post(baseApiUrl + 'ServiceControlId/abrirCatraca?access_token=' + sessionStorage.getItem('accToken'), { terminalId: item.id })
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.$refs.chamaSnackbar.snack("green", "Comando de abrir catraca enviado ao leitor!", "SUCESSO")
            this.carregaTerminais(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
          }
        })
        .catch(() => {
          this.isLoading = false
          this.$refs.chamaSnackbar.snack("red", "Problema ao abrir catraca", "DESCULPE")
        })
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
  
  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>